export const blue = {
  400: "#025EA6",
  500: "#014174",
};

export const green = {
  100: "#20907719",
  300: "#267D69",
  400: "#00664F",
};

export const limeGreen = {
  400: "#85b70a",
};

export const yellow = {
  100: "#FFC84519",
  400: "#ffc844",
  500: "#FFC845",
};

export const orange = {
  400: "#ff9d14",
};

export const red = {
  100: "#BE3A3419",
  400: "#BE3A35",
};

export const neutral = {
  100: "#ffffff",
  200: "#f3f3f3",
  300: "#DEE0E2",
  400: "#6F777B",
  500: "#0B0C0C",
  600: "#000000",
};

export const grey = {
  200: "#F5F6F6",
  201: "#F2F2F3",
  202: "#DEE0E2",
  300: "#F8F8F8",
  350: "#c1c1c1",
  400: "#525A5B",
  500: "#ECF1F0",
  700: "#6F777B",
  800: "#585858",
};
